
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ChangeDetectionStrategy, inject, output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, UserChildren } from 'app/Services/auth.service';
import { QdmService } from 'app/Services/qdm.service';
import { combineLatest, Subscription } from 'rxjs';

@Component({
    imports: [],
    template: `
    <div class="w-full flex flex-wrap gap-2 p-2 px-6">
      @for (child of childrens; track child) {
        <div
          class="border-gris-3 text-white cursor-pointer bg-white rounded-md shadow-sm p-2 hover:shadow transition-all duration-200 border border-transparent hover:border-orange-1 flex items-center gap-2"
          [class.border-orange-1]="selectedChild && selectedChild.id === child.id"
          [class.bg-orange-1]="selectedChild && selectedChild.id === child.id"
          [class.text-white]="selectedChild && selectedChild.id === child.id"
          [class.text-black]="selectedChild && selectedChild.id !== child.id"
          (click)="selectChild(child)"
          >
          <div
            class="h-6 w-6 rounded-full bg-vert-1 flex items-center justify-center text-xs font-medium"
            >
            {{ child.firstname.charAt(0).toUpperCase() }}
          </div>
          <span class="text-xs font-medium">
            {{
            child.firstname.charAt(0).toUpperCase() + child.firstname.slice(1)
            }}
            {{ child.lastname.toUpperCase().substring(0, 1) }}
          </span>
        </div>
      }
    
      @if (childrens.length === 0) {
        <div
          class="w-full text-center p-2 text-xs text-gray-500"
          >
          Aucun enfant disponible
        </div>
      }
    </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-child-selector'
})
export class ChildSelectorComponent implements OnInit, OnDestroy {
  private qdm = inject(QdmService);
  private auth = inject(AuthService);
  private cdr = inject(ChangeDetectorRef);
  private router = inject(Router);

  childrens: UserChildren[] = [];
  selectedChild: UserChildren | null = null;

  sub: Subscription = new Subscription();

  readonly childSelected = output<UserChildren>();

  ngOnInit(): void {
    this.sub.add(this.qdm.selectChild$.subscribe((child) => {
      this.selectedChild = child;
      this.cdr.detectChanges();
    }));

    this.sub.add(combineLatest([this.auth.user$, this.qdm.selectedEnterprise$, this.qdm.selectedRestaurant$]).subscribe(([user, momentRepas, restaurant]) => {
      this.childrens = (user?.children || []).filter((child) => {
        return child.schoolInfos.id === momentRepas?.id;
      });

      if (this.childrens.length > 0 && (!this.selectedChild || this.childrens.find((c) => c.id === this.selectedChild?.id) === undefined)) {
        this.selectChild(this.childrens[0]);
      }

      if(this.childrens.length === 0 && this.auth.userSubject.value?.isSchoolMode) {
        this.router.navigate(["/restaurant/" + restaurant?.id + "/school-no-childs"]);  
      }
    }));
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  selectChild(child: UserChildren) {
    this.selectedChild = child;
    this.cdr.detectChanges();
    this.qdm.selectedChildSubject.next(child);
    this.childSelected.emit(child);
  }
}
